import { Link } from "gatsby";
import { SOLUTIONS_URL } from "../../../../src/constants/pageUrls";
import * as React from 'react';
export default {
  Link,
  SOLUTIONS_URL,
  React
};